<template>
    <Dialog v-if="showQrCodeButton" v-model:visible="QRCodeScannerEnabled" header="Scan QR-code">
        <QrScanner />
    </Dialog>
    <div class="flex w-full gap-5 h-full horse-pending-list-view">
        <LibyanOrnament vertical class="lib-or mr-5" />
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.horsePending.header') }}</h2>
                <CustomButton v-if="showQrCodeButton" label="Scan qr-code" @click="scanQrCode" />
            </div>
            <HorsePendingTable ref="horsePendingTable" />
        </div>
    </div>
</template>

<script>
    import LibyanOrnament from '@/components/LibyanOrnament.vue';
    import HorsePendingTable from './components/HorsePendingTable.vue';
    import { FilterMatchMode } from 'primevue/api';
    import CustomButton from "@/components/form/CustomButton.vue";
    import {SystemRole} from "@/utils/SystemRole";
    import Dialog from "primevue/dialog";
    import QrScanner from "@/views/pending/components/QrScanner.vue";

    export default {
        name: "HorsePendingView",

        components: {
            CustomButton,
            QrScanner,
            HorsePendingTable,
            LibyanOrnament,
            Dialog,
        },

        data() {
            return {
                QRCodeScannerEnabled: false,
                systemRole: SystemRole.getUserRole(),
            }
        },

        methods: {
            scanQrCode() {
                this.QRCodeScannerEnabled = !this.QRCodeScannerEnabled;
            },
            showQrCodeButton() {
                return this.systemRole === SystemRole.ADMIN || this.systemRole === SystemRole.LAB_USER;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .horse-pending-list-view {
        @media screen and (max-width: 750px) {
            .lib-or {
                display: none;
            }
        }
        @media screen and (max-width: 650px) {
            padding: 0 20px;
        }
    }
</style>
